import { combineReducers } from "redux";
import { produce } from "immer";
import authReducer from "./auth.slice";
import themReducer from "./theme.slice";
import branchReducer from "./branches.slice";
import notificationReducer from "./notification.slice";
import entryTypesReducer from "./entryTypes.slice";
import categoryReducer from "./category.slice";
import usersReducer from "./users.slice";
import promosReducer from "./promos.slice";
import carsReducer from "./cars.slice";
import transactionsReducer from "./transactions.slice";
import groupsReducer from "./groups.slice";
import instructorReducer from "./instructors.slice";
import lessonTimesReducer from "./lessonTimes.slice";
import partnersReducer from "./partners.slice";

const appReducer = combineReducers({
  theme: themReducer,
  auth: authReducer,
  branches: branchReducer,
  notification: notificationReducer,
  entryTypes: entryTypesReducer,
  categories: categoryReducer,
  users: usersReducer,
  promos: promosReducer,
  cars: carsReducer,
  transactions: transactionsReducer,
  groups: groupsReducer,
  instructors: instructorReducer,
  lessonTimes: lessonTimesReducer,
  partners: partnersReducer,
});

const rootReducer = (state, action) => {
  const nextState = produce(state, (draftState) => {
    if (action.type === "branches/changeBranchSuccess") {
      Object.keys(draftState).forEach((key) => {
        if (!["auth", "theme", "branches"].includes(key)) {
          draftState[key] = undefined;
        }
      });
    }

    if (action.type === "auth/logoutSuccess") {
      Object.keys(draftState).forEach((key) => {
        if (!["theme"].includes(key)) {
          draftState[key] = undefined;
        }
      });
    }
  });

  return appReducer(nextState, action);
};

export default rootReducer;
